/**
 * @generated SignedSource<<7a4a8d69fd4c9660c19ed4532bd9ba9b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user$data = {
  readonly showRedactionChangeBoardingOnIssueViewAsEditor: boolean | null | undefined;
  readonly showRedactionChangeBoardingOnIssueViewAsViewer: boolean | null | undefined;
  readonly " $fragmentType": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user";
};
export type onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user$key = {
  readonly " $data"?: onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "showRedactionChangeBoardingOnIssueViewAsViewer"
    },
    {
      "kind": "ScalarField",
      "name": "showRedactionChangeBoardingOnIssueViewAsEditor"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "4a6b24a65a54b20cc96b85dbab1d2920";

export default node;
